import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import OptimizedImage from '@/components/OptimizedImage';
import GrainTexture from '@/components/GrainTexture';
import GeoPattern from '@/components/GeoPattern';
import heroImage from '@/assets/systemique/home-hero.webp';

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const services = [
    'Organisatieopstellingen',
    'Systemische leergang voor leiders',
    'Systemische teamcoaching'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 3000); // Wisselt elke 3 seconden

    return () => clearInterval(interval);
  }, [services.length]);

  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 bg-[#F2EADF]">
      <GeoPattern />
      
      {/* Achtergrond afbeelding overlay */}
      <div className="absolute inset-0 z-0 opacity-20 mix-blend-overlay">
        <OptimizedImage 
          src={heroImage} 
          webpSrc={heroImage}
          alt="Systemisch werk hero afbeelding" 
          className="w-full h-full object-cover"
          priority={true}
          width={1600}
          height={1067}
        />
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-tr from-[#6E3B63]/40 via-[#F9EBEF]/30 to-transparent rounded-full blur-3xl opacity-60 animate-pulse-slow"></div>
      <GrainTexture opacity={0.3} />

      <div className="relative max-w-5xl mx-auto px-6 text-center z-10">
        <div className="animate-fade-up">
          <span className="inline-block mb-4 text-xs font-bold tracking-[0.3em] uppercase text-[#590D0D]">Systemisch Werk & Coaching</span>
          <p className="text-sm md:text-base text-[#6E3B63]/70 mb-6 font-light tracking-wide min-h-[1.5rem] transition-opacity duration-500">
            {services[currentIndex]}
          </p>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[1.1] mb-8 text-[#6E3B63]">
            Inzicht in <br />
            <span className="italic font-light font-serif">dynamiek</span> & <br />
            patronen
          </h1>
          <p className="text-lg md:text-xl text-[#6E3B63]/80 max-w-2xl mx-auto mb-4 leading-relaxed font-light">
            Doorbreek patronen, krijg grip op de onderstroom
          </p>
          <p className="text-lg md:text-xl text-[#6E3B63]/80 max-w-2xl mx-auto mb-12 leading-relaxed font-light">
            Ontdek wat de groei van jouw organisatie tegenhoudt. Wij maken de remmende patronen inzichtelijk, zodat jullie weer volle kracht vooruit kunnen.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <Button 
              asChild 
              variant="default"
              size="lg" 
              className="bg-[#854C73] shadow-lg hover:scale-105 before:absolute before:inset-0 before:bg-[#590D0D] before:translate-x-[-100%] before:transition-transform before:duration-300 hover:before:translate-x-0 before:z-0"
            >
              <Link to="/aanbod" className="relative z-20 flex items-center gap-2 text-white">
                <span className="relative z-20 text-white">Bekijk aanbod voor bedrijven</span> <ArrowRight size={18} className="ml-2 relative z-20 text-white" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-[#854C73] text-[#6E3B63] hover:bg-[#854C73]/10">
              <Link to="/leergang-onderstroom">Systemische leergang voor leiders</Link>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;